import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { LoginButton } from './LoginButton';
import { LoginErrorAlert } from './LoginErrorAlert';

/** Call-to-action block for the login screen: welcome text, login button and error display. */
export function LoginCta() {
  return (
    <Box id="login-cta">
      <Box sx={{ mb: 3 }}>
        <Typography component="h1" variant="h4" mb={1}>
          <FormattedMessage id="auth.loginScreen.welcome" defaultMessage="¡Bienvenido!" />
        </Typography>
        <Typography
          component="p"
          variant="body1"
          sx={{ fontSize: '1.25rem', color: 'text.secondary' }}
        >
          <FormattedMessage
            id="auth.loginScreen.prompt"
            defaultMessage="Inicia sesión en MediaInbox con tu cuenta"
          />
        </Typography>
      </Box>
      <LoginButton />
      <LoginErrorAlert />
    </Box>
  );
}
